import { render } from "./ModalImageComponent.vue?vue&type=template&id=3e12c8dd"
import script from "./ModalImageComponent.vue?vue&type=script&lang=js"
export * from "./ModalImageComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Unimagem\\diaMundialdoRim\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__